import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { onImgError } from "../lib/imageFallback";

function fmtDate(d) {
  try { return new Date(d).toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return d; }
}

export function ArticleCard({ article, size = "default" }) {
  const a = article;
  const big = size === "lead";
  const compact = size === "compact";
  // All PictureThisInk covers are 16:9 — use a 16:9 frame with object-contain so the full cover shows, never cropped.
  return (
    <article data-testid={`article-card-${a.slug}`} className="group bg-white">
      <Link to={`/article/${a.slug}`} className="block">
        <div className="overflow-hidden aspect-video bg-white">
          <img src={a.cover_image} alt={a.cover_alt || a.title} loading="lazy" onError={onImgError}
            className="block w-full h-full object-contain object-center" />
        </div>
        <div className="pt-3">
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider font-bold">
            <span className="text-pti-red">{a.category}</span>
            <span className="text-gray-400">·</span>
            <span className="text-gray-500">{fmtDate(a.published_date)}</span>
            {a.sponsored && <span className="ml-1 bg-gray-900 text-white px-1.5 py-0.5 text-[9px]">SPONSORED</span>}
          </div>
          <h3 className={`font-display font-bold leading-tight mt-1.5 group-hover:text-pti-red transition-colors ${big ? "text-3xl sm:text-4xl" : compact ? "text-base" : "text-lg"}`}>
            {a.title}
          </h3>
          {big && a.excerpt && <p className="text-gray-600 mt-2 line-clamp-3 text-base">{a.excerpt}</p>}
        </div>
      </Link>
      {a.author && (
        <Link to={`/creators/${a.author.username}`} className="flex items-center gap-2 mt-3" data-testid={`byline-${a.slug}`}>
          <img src={a.author.avatar || "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=100"} alt="" className="w-6 h-6 rounded-full object-cover bg-gray-200" />
          <span className="text-xs font-semibold flex items-center gap-1">
            {a.author.display_name}
            {a.author.verified && <CheckCircle2 size={12} className="text-pti-red" aria-label="Verified" />}
          </span>
          <span className="text-xs text-gray-400">· {a.read_time} min read</span>
        </Link>
      )}
    </article>
  );
}
